"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitOrgAndBranch = void 0;
function splitOrgAndBranch(full) {
    var e_1, _a;
    var ORG_SUFFIXES = [
        { full: "協同組合連合会", short: "協連" },
        { full: "協同組合", short: "協組" },
        { full: "信用金庫", short: "信金" },
        { full: "信用組合", short: "信組" },
        { full: "中央金庫", short: "中金" },
        { full: "労働金庫", short: "労金" },
        { full: "銀行" },
    ];
    var trimmed = full.replace(/\s+/g, "");
    var hit = null;
    try {
        for (var ORG_SUFFIXES_1 = __values(ORG_SUFFIXES), ORG_SUFFIXES_1_1 = ORG_SUFFIXES_1.next(); !ORG_SUFFIXES_1_1.done; ORG_SUFFIXES_1_1 = ORG_SUFFIXES_1.next()) {
            var _b = ORG_SUFFIXES_1_1.value, f = _b.full, short = _b.short;
            var iFull = trimmed.indexOf(f);
            if (iFull !== -1) {
                hit = { full: f, match: f, idx: iFull };
                break;
            }
            if (short) {
                var iShort = trimmed.indexOf(short);
                if (iShort !== -1) {
                    hit = { full: f, match: short, idx: iShort };
                    break;
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (ORG_SUFFIXES_1_1 && !ORG_SUFFIXES_1_1.done && (_a = ORG_SUFFIXES_1.return)) _a.call(ORG_SUFFIXES_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (!hit) {
        return ["", ""];
    }
    var orgEnd = hit.idx + hit.match.length;
    var prefix = trimmed.slice(0, hit.idx);
    var rest = trimmed.slice(orgEnd);
    var orgName = prefix + hit.full;
    var branchName = rest;
    return [orgName, branchName];
}
exports.splitOrgAndBranch = splitOrgAndBranch;
